/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: utils/validators.ts
 🗓️ Created: 2025-01-27
 🧩 Description:
    Validation functions for DISA Entries forms.
────────────────────────────────────────────────────────────────*/

import { FormState, ValidationErrors, DISA_NAME_MAX, PASSWORD_MAX } from '../types';

/**
 * Validate DISA entry form
 */
export function validateDisaEntryForm(
  formData: FormState,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  t: (key: string, params?: any) => string
): ValidationErrors {
  const errors: ValidationErrors = {};

  if (!formData.name.trim()) {
    errors.name = t('disaEntries:validation.nameRequired');
  } else if (formData.name.length > DISA_NAME_MAX) {
    errors.name = t('disaEntries:validation.nameTooLong', { max: DISA_NAME_MAX });
  }

  if (!formData.password.trim()) {
    errors.password = t('disaEntries:validation.passwordRequired');
  } else if (formData.password.length > PASSWORD_MAX) {
    errors.password = t('disaEntries:validation.passwordTooLong', { max: PASSWORD_MAX });
  }

  if (formData.settings.responseTimeout < 1 || formData.settings.responseTimeout > 60) {
    errors.responseTimeout = t('disaEntries:validation.responseTimeoutRequired');
  }

  if (formData.settings.digitTimeout < 1 || formData.settings.digitTimeout > 10) {
    errors.digitTimeout = t('disaEntries:validation.digitTimeoutRequired');
  }

  if (formData.settings.maxCallDuration < 60 || formData.settings.maxCallDuration > 3600) {
    errors.maxCallDuration = t('disaEntries:validation.maxCallDurationRequired');
  }

  if (formData.settings.maxAttempts < 1 || formData.settings.maxAttempts > 5) {
    errors.maxAttempts = t('disaEntries:validation.maxAttemptsRequired');
  }

  return errors;
}

